import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';

import {AuthGuard} from './auth/auth.guard';
import {VorgangsartResolver} from './resolver/vorgangsart.resolver';
import {MitarbeiterResolver} from './resolver/mitarbeiter.resolver';
import {PdfViewerRoute} from '@adnova/jf-ng-components';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/overview',
    pathMatch: 'full',
  },
  {
    path: 'edit',
    loadChildren: () => import('./modules/edit/edit.module').then(m => m.EditModule),
    canActivate: [AuthGuard],
    resolve: [VorgangsartResolver, MitarbeiterResolver],
    data: {
      redirectAllowed: true,
      useInhaberService: true,
    },
  },
  {
    path: 'splice',
    loadChildren: () => import('./modules/splice/splice.module').then(m => m.SpliceModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'overview',
    loadChildren: () => import('./modules/overview/overview.module').then(m => m.OverviewModule),
    canActivate: [AuthGuard],
    resolve: [VorgangsartResolver],
    data: {
      redirectAllowed: true,
      useInhaberService: true,
    },
  },
  {
    path: 'legal/impressum',
    loadComponent: () => import('./modules/impressum/impressum.component').then(m => m.ImpressumComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'widget/utility-widget',
    loadChildren: () =>
      import('./modules/widget/utility-widget/utility-widget.module').then(m => m.UtilityWidgetModule),
    canActivate: [AuthGuard],
    data: {
      redirectAllowed: true,
      useInhaberService: true,
    },
  },
  {
    path: 'error',
    loadChildren: () => import('./modules/error-pages/error-pages.module').then(m => m.ErrorPagesModule),
    canActivate: [AuthGuard],
  },
  PdfViewerRoute,
  {
    path: '**',
    redirectTo: '/overview',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  providers: [VorgangsartResolver, MitarbeiterResolver],
  exports: [RouterModule],
})
export class AppRoutingModule {}
